import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import IconChips from './IconChips';
import ClientProvider from './client';
export default createDemo(import.meta.url, IconChips, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/chips/demos/icon/IconChips.tsx",
    "fileName": "IconChips.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Chip from '@mui/material/Chip';\nimport Stack from '@mui/material/Stack';\nimport FaceIcon from '@mui/icons-material/Face';\n\nexport default function IconChips() {\n  return (\n    <Stack direction=\"row\" spacing={1}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Chip icon={<FaceIcon />} label=\"With Icon\" />\n      <Chip icon={<FaceIcon />} label=\"With Icon\" variant=\"outlined\" />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 12,
        "focusedLines": 2,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Chip from '@mui/material/Chip';\nimport Stack from '@mui/material/Stack';\nimport FaceIcon from '@mui/icons-material/Face';\n\nexport default function IconChips() {\n  return (\n    <Stack direction=\"row\" spacing={1}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Chip icon={<FaceIcon />} label=\"With Icon\" />\n      <Chip icon={<FaceIcon />} label=\"With Icon\" variant=\"outlined\" />\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Chip"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "icon"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "FaceIcon"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "With Icon",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Chip"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "icon"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "FaceIcon"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "With Icon",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "outlined",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 12,
    "focusedLines": 2,
    "collapsible": true,
    "externals": [
      "@mui/material/Chip",
      "@mui/material/Stack",
      "@mui/icons-material/Face"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
